import { render, staticRenderFns } from "./BusDetails.vue?vue&type=template&id=3414ed16&scoped=true"
import script from "./BusDetails.vue?vue&type=script&lang=js"
export * from "./BusDetails.vue?vue&type=script&lang=js"
import style0 from "./BusDetails.vue?vue&type=style&index=0&id=3414ed16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3414ed16",
  null
  
)

export default component.exports